import { useSymbioteSocket } from '@/hooks/useWebSocket';
import { WS_FALLBACK_POLL_MS } from '@/hooks/wsInvalidation';

/**
 * Returns a pollingInterval suitable for spreading into RTK Query hook options.
 * Polls at WS_FALLBACK_POLL_MS when WebSocket is not connected, 0 (disabled) when connected.
 *
 * Usage:
 *   const fallback = useWsFallbackPolling();
 *   const { data } = useGetQcResultsQuery(params, { ...fallback });
 */
export function useWsFallbackPolling(): { pollingInterval: number } {
  const { status } = useSymbioteSocket();
  return { pollingInterval: status === 'connected' ? 0 : WS_FALLBACK_POLL_MS };
}
